<script>
  import { createEventDispatcher } from 'svelte';
  import Avatar from '@components/Avatar.svelte';
  import Dropdown from '@components/Dropdown.svelte';
  import Switch from '@components/Switch.svelte';

  const dispatch = createEventDispatcher();
  const ROLE_OPTIONS = [
    { label: 'Can view', value: 'viewer' },
    { label: 'Can edit', value: 'contributor' },
  ];

  export let showEmails = false;
  export let editable = false;
  export let users = [];
  export let mobile = false;
</script>

<style style="text/scss" lang="scss">
  .users-container {
    .user-container {
      display: flex;
      width: 100%;
      align-items: center;
    }
  }
</style>

<div class="users-container">
  <div>
    {#each users as user}
      <div class="user-container">
        <div style="margin-right: 20px; flex-shrink: 0">
          <svg
            on:click|preventDefault|stopPropagation={() => {
              dispatch('remove', { data: user });
            }}
            style="margin-top: -2px; cursor: pointer;"
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.74169 0.25831C7.39728 -0.0861033 6.83888 -0.0861031 6.49446
              0.25831L4 2.75278L1.50554 0.25831C1.16112 -0.0861033 0.602721
              -0.0861033 0.258309 0.25831C-0.0861032 0.602723 -0.0861029 1.16113
              0.258309 1.50554L2.75277 4.00001L0.258333 6.49446C-0.0860796
              6.83887 -0.0860799 7.39728 0.258332 7.74169C0.602744 8.0861
              1.16115 8.0861 1.50556 7.74169L4 5.24724L6.49444 7.74169C6.83885
              8.0861 7.39726 8.0861 7.74167 7.74169C8.08608 7.39728 8.08608
              6.83887 7.74167 6.49446L5.24723 4.00001L7.74169 1.50554C8.0861
              1.16113 8.0861 0.602723 7.74169 0.25831Z"
              fill="#FF5567" />
          </svg>
        </div>
        <div style="margin-right: 15px; flex-shrink: 0">
          {#if user.name == 'Invited User'}
            <Avatar src={user.avatar_url} size={27} user={user} mobile={mobile} />
          {:else}
            <Avatar href={user.profile_path} src={user.avatar_url} size={27} user={user} mobile={mobile} />
          {/if}
        </div>
        <div style="flex: 1">
          {#if showEmails}
            {#if user.name}
              <div>{user.name}</div>
            {/if}
            {#if user.email}
              <div>{user.email}</div>
            {/if}
          {:else if user.name && user.name != 'Invited User'}
            <div>{user.name}</div>
          {:else}
            <div>{user.email}</div>
          {/if}
        </div>
        {#if editable && !mobile}
          <div style="flex-shrink: 0;">
            <Dropdown
              selectedOption={ROLE_OPTIONS.find((x) => x.value == user.role)}
              options={ROLE_OPTIONS}
              on:selected={(e) => {
                dispatch('role-selected', {
                  user: user,
                  role: e.detail.option.value,
                });
              }} />
          </div>
        {/if}
      </div>
      {#if editable && mobile}
        <div style="margin-bottom: 30px; margin-top: 7px;">
          <Switch
            selected={user.role === 'viewer' ? 'View' : 'Edit'}
            options={['View', 'Edit']}
            on:selected={(e) => {
              dispatch('role-selected', {
                user: user,
                role: e.detail.option == 'View' ? 'viewer' : 'contributor',
              });
            }} />
        </div>
      {/if}
    {/each}
  </div>
</div>
